
<template>
<div class='homepage_left' :class="{'closeBtn':pageshow}">
  <div class="centerDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>水库水情</span>
      </div>
      <div class="more">
        <!-- 乡镇检索 -->
         <div class="townSearch">
          <el-input @change="getStatisticsReservoirWater" size="small" placeholder="请输入终端名称" v-model="staname" clearable>
            <i @click="getStatisticsReservoirWater" slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="chartMain"  ref="centerTable" v-loading="loading2">
      <el-table ref="reservoirTable" :data="waterData" style="width: 100%" :max-height="tableHeight" @row-click="changeSt" highlight-current-row :row-class-name="reservoirWaterRowClass" :cell-style="warningTimeStyle">
        <el-table-column type="index" align="center" label="序号" min-width="60"></el-table-column>
        <el-table-column prop="stnm" label="终端名称" align="center" min-width="120" sortable>
          <template slot-scope="scope" >
            <!-- <span style="cursor:pointer">{{scope.row.stnm}}</span> -->
            <el-tooltip effect="light" :content="scope.row.stcd" placement="top" popper-class="hiddenOverflow">
              <span style="cursor:pointer">{{scope.row.stnm}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="addvnm" label="乡镇" align="center"  :width="cellWidth" sortable></el-table-column>s
        <el-table-column prop="water" label="水位" align="center" sortable  :sort-method="sortChange1"  :width="cellWidth">
          <template slot-scope="scope">
            <span>{{scope.row.water_Str}} </span>
            <i v-if="scope.row.diffLastHourWater>0" style="color: #e02020;font-size:18px" class="el-icon-top"></i>
            <i v-else-if="scope.row.diffLastHourWater<0" style="color: #6dd400;font-size:18px" class="el-icon-bottom"></i>
            <i v-else-if="scope.row.diffLastHourWater===0" style="color: #fff;font-size:18px" class="el-icon-right"></i>
          </template>
        </el-table-column>
        <el-table-column prop="overflowWarningWater" label="超汛限" align="center" sortable :sort-method="sortMethod" :width="cellWidth">
        </el-table-column>
        <el-table-column prop="timeStr" label="时间" align="center"  :width="cellWidth"></el-table-column>
      </el-table>
    </div>
  </div>
  <div class="bomDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>{{stnm}}</span>
      </div>
      <div class="more">
      </div>
    </div>
    <div class="chartMain">
      <div class="reservoirDiv" v-loading="loading3">
        <div class="duanmianChart">
          <div id="reservoirLine" ref="reservoirLine"></div>
          <div class="duanmianDiv" >
            <img src="@/assets/homepage_img_ptcopy/duanmian.png">
          </div>
          <!-- <div id="piechart"></div> -->
          <div class="wave">
            <wave :y="-waveY"></wave>
          </div>
          <!-- <div class="wavelow">
            <wave :y="-10"></wave>
          </div> -->
          <!-- <div class="chartname">{{stnm}}</div> -->
          <div class="overrun" v-show="overflowWarningWater>0">超限{{overflowWarningWater}}m</div>
        </div>
      </div>
    </div>
  </div>
  <div class="showBtn flexC"  @click="showpage"><i class="el-icon-caret-left" :class="{'tran180':pageshow}"></i></div>
</div>
</template>

<script>
import api from '@/api/homepage_ptcopy'
import wave from '@/components/stationDialog/wave'
export default {
  components: { wave },
  data () {
    return {
      staname: '',
      loading1: false,
      loading2: false,
      loading3: false,
      rainData: [],
      firstData: [{ name: '总座数', num: 42 }, { name: '蓄水率', num: 0 }, { name: '平均可纳雨量', num: 0 }],
      duanmianHeight: 0,
      BeginTime: '',
      EndTime: '',
      stid: '', // 当前测站编码
      stnm: '',
      waterNow: 0,
      impoundmentRate: null,
      ssw: null,
      tableHeight: 380,
      overflowWarningWater: 0,
      waterData: [],
      tideData: [],
      stinfo: {},
      timer: null,
      pageshow: false,
      reservoirH: 0,
      reservoirW: 0,
      waveY: 30,
      cellWidth: '60', // 表格cell宽度
      perRowHeight: 0,
      minSortNum: 0 // 排序默认超汛限最小数字
    }
  },
  computed: {},
  watch: {},
  methods: {
    sortChange1 (a, b) {
      // return a.water - b.water
      let bsort = b.water === undefined ? -1 : b.water
      let asort = a.water === undefined ? -1 : a.water
      return bsort - asort
    },
    showpage () {
      this.pageshow = !this.pageshow
      this.$emit('rePosition', this.pageshow)
    },
    setRow (id) {
      let tableDom = this.$refs.reservoirTable
      tableDom.tableData.forEach((item, index) => {
        if (item.stid === id) {
          tableDom.setCurrentRow(item)
          this.$nextTick(() => {
            document.querySelector('.homepage_left').querySelector('.el-table__body-wrapper').scrollTo(0, this.perRowHeight * index)
          })
        }
      })
    },
    changeSt (data, column) {
      this.stid = data.stid
      this.stnm = data.stnm
      this.waterNow = data.water
      this.impoundmentRate = data.impoundmentRate
      this.ssw = data.ssw
      this.get5MYuRunData()
      // this.drawPieChart(data.impoundmentRate)
      // 地图联动
      this.$emit('showPoint', data)
      if (column.label === '站名') {
        this.$emit('showDialog', data)
      }
    },
    // 获取 水库总数,蓄水率,平均可纳雨量
    getReserviorRate () {
      api.getReserviorRate({}).then(res => {
        // console.log(res, 'ceshi')
        // this.firstData[0].num = res.data.ReserviorNum
        this.firstData[0].num = 42 // 暂时写死
        this.firstData[1].num = res.data.ReserviorRate
        this.firstData[2].num = Math.round(res.data.RainArea)
      })
    },
    sortMethod (a, b) {
      let bsort = (b.overflowWarningWater === undefined || b.overflowWarningWater === null) ? this.minSortNum - 1 : b.overflowWarningWater
      let asort = (a.overflowWarningWater === undefined || a.overflowWarningWater === null) ? this.minSortNum - 1 : a.overflowWarningWater
      return bsort - asort
    },
    // 获取水库
    getStatisticsReservoirWater () {
      this.loading2 = true
      api.getStatisticsReservoirWater({
        SID: this.$store.state.sid,
        StationName: this.staname
      }).then(res => {
        this.loading2 = false
        let data = res.data.rows
        this.waterData = data
        this.waterData.forEach((item, i) => {
          if (item.time) {
            // let arr = item.time.split(' ')
            this.waterData[i].timeStr = item.time.slice(5)
          }
          if (item.addvnm) {
            let reg1 = new RegExp('镇', 'g')// g代表全部
            let reg2 = new RegExp('街道', 'g')// g代表全部
            let reg3 = new RegExp('岛管委会', 'g')// g代表全部
            this.waterData[i].addvnm = item.addvnm.replace(reg1, '').replace(reg2, '').replace(reg3, '')
          }
        })
        let filterWaterData = this.waterData.filter(item => { // 过滤数组中undefined与null类型
          return item.overflowWarningWater !== undefined && item.overflowWarningWater !== null
        })
        // 获取对象中属性的最小值
        let min = Math.min.apply(Math, filterWaterData.map(item => { return item.overflowWarningWater }))
        this.minSortNum = min
        this.waterData = this.waterData.sort((a, b) => {
          // return b.overflowWarningWater - a.overflowWarningWater
          let bsort = (b.overflowWarningWater === undefined || b.overflowWarningWater === null) ? this.minSortNum - 1 : b.overflowWarningWater
          let asort = (a.overflowWarningWater === undefined || a.overflowWarningWater === null) ? this.minSortNum - 1 : a.overflowWarningWater
          return bsort - asort
        })
        this.$nextTick(() => {
          let temp = document.getElementsByClassName('el-table__row')
          this.perRowHeight = temp[0].offsetHeight
        })
        this.stid = data[0].stid
        this.stnm = data[0].stnm
        this.waterNow = data[0].water
        this.impoundmentRate = data[0].impoundmentRate
        this.ssw = data[0].ssw
        // this.overflowWarningWater = data[0].overflowWarningWater
        this.get5MYuRunData()
        // this.drawPieChart(data[0].impoundmentRate)
      })
    },
    // 获取水库5分钟水雨情
    get5MYuRunData () {
      this.loading3 = true
      api.get5MYuRunData({
        SID: this.$store.state.sid,
        STID: this.stid,
        EndTime: this.EndTime,
        BeginTime: this.BeginTime
      }).then(res => {
        this.loading3 = false
        let data = res.data
        this.drawLineChart(data)
      })
    },
    drawLineChart (data) {
      let xData = []
      let waterData = [] //
      let wrzData = [] // 警戒水位
      let waterMaxData = []// 用以比较
      let sswData = [] // 死水位
      data.runData_Reservoir.forEach((el, i) => {
        let dateArr = el.date.split(' ')
        let date = dateArr[0].split('-')
        xData.push(date[1] + '-' + date[2] + ' ' + dateArr[1])
        if (el.alert !== 0) {
          wrzData.push(el.alert)
        }
        // waterData.push(el.value)
        waterData.push(this.waterNow)
        sswData.push(this.ssw)
        if (el.value) {
          waterMaxData.push(el.value)
        }
      })
      let ymin = 0
      let ymax = 0
      let labelAlert = [12, -12]
      let labelNow = [12, -12]
      let labelSsw = [12, 5]
      // if (wrzData[0]) {
      //   if (this.impoundmentRate) {
      //     let y = wrzData[0] * this.impoundmentRate / 100
      //     ymin = ((wrzData[0] - this.waterNow) * y / (wrzData[0] - y) - this.waterNow) * -1 // (wrzData[0] - y)/(y-0) = (wrzData[0] - this.waterNow)/(this.waterNow-ymin)求ymin
      //   }
      //   ymax = (wrzData[0] - ymin) / 7 * 3 + wrzData[0]
      //   if (this.waterNow > wrzData[0]) {
      //     labelAlert = [12, 5]
      //     labelNow = [12, -12]
      //   }
      // } else {
      //   ymax = Math.max(...waterMaxData)
      //   ymax = ymax * 10 / 7
      // }
      if (wrzData[0]) {
        if (this.ssw) {
          let gap = (wrzData[0] - this.ssw) / 4
          ymin = this.ssw - 2 * gap
          if (this.waterNow - wrzData[0] > gap) {
            for (let i = 0; i < waterData.length; i++) {
              waterData[i] = wrzData[0] + gap
            }
          }
          if (this.waterNow > wrzData[0]) {
            labelAlert = [12, 5]
            labelNow = [12, -12]
          } else if (wrzData[0] > this.waterNow && this.waterNow > sswData[0]) {
            if (wrzData[0] - this.waterNow < gap) {
              labelNow = [12, 5]
            } else if (this.waterNow - sswData[0] < gap) {
              labelNow = [12, -12]
            }
          } else if (sswData[0] > this.waterNow) {
            if (sswData[0] - this.waterNow < gap) {
              labelSsw = [12, -12]
              labelNow = [12, 5]
            } else if (sswData[0] - this.waterNow > gap) {
              labelSsw = [12, -12]
              labelNow = [12, -12]
              for (let i = 0; i < waterData.length; i++) {
                waterData[i] = sswData[0] - gap
              }
            }
          }
        }
        ymax = (wrzData[0] - ymin) / 7 * 3 + wrzData[0]
      } else {
        ymax = Math.max(...waterMaxData)
        ymax = ymax * 10 / 7
      }
      let svgH = (waterData[0] - ymin) / (ymax - ymin) * this.reservoirH // svg理论像素高度
      let svgPx = this.reservoirW / 100 //  100为svg画布宽度,svg 1单位大小和像素的比例
      this.waveY = svgH / svgPx - 10 // 10 为svg高度为0的位置
      let myChart = this.$echarts.init(document.getElementById('reservoirLine'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '0%',
          right: '0%',
          bottom: '0%',
          top: '0%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          show: false,
          data: xData,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        }],
        yAxis: [
          {
            type: 'value',
            min: ymin,
            max: ymax,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '水位',
            type: 'line',
            smooth: true,
            symbol: 'none',
            data: waterData,
            itemStyle: {
              color: '#fff'
            },
            lineStyle: {
              normal: {
                color: '#fff',
                width: 1
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelNow,
                formatter: `当前水位: ${this.waterNow.toFixed(2)}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            }
          },
          {
            name: '汛限水位',
            type: 'line',
            itemStyle: {
              color: '#FFA500'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: '#FFA500',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelAlert,
                formatter: `汛限水位: ${wrzData[0]}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            },
            data: wrzData
          },
          {
            name: '死水位',
            type: 'line',
            itemStyle: {
              color: 'yellow'
            },
            symbolSize: 0,
            lineStyle: {
              normal: {
                type: 'dotted',
                color: 'yellow',
                width: 2
              }
            },
            markPoint: {
              data: [
                { type: 'max', name: '最大值' }
              ],
              symbol: 'path://M958.417329 735.20866501l-446.417329-446.41733001-446.417329 446.41733001z',
              symbolSize: [12, 0],
              label: {
                position: labelSsw,
                formatter: `死水位: ${sswData[0]}m`,
                textStyle: {
                  fontSize: '15'
                }
              }
            },
            data: sswData
          }
        ]
      })
    },
    reservoirWaterRowClass ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        return 'warning-red-row'
      }
      return ''
    },
    warningTimeStyle ({ row, column, rowIndex, columnIndex }) {
      let stylejson = {
        'color': 'yellow'
      }
      if (row.time) { // 时间超过30分钟为异常数据
        let time = row.time.replace(/-/g, '/')
        let date = new Date(time)
        time = date.getTime()
        let now = new Date().getTime()
        if ((now - time) / 1000 / 60 > 30) {
          return stylejson
        }
      } else {
        return stylejson
      }
      return ''
    },
    getCurrentTime (num) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000 * Number(num))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (mm > 9 ? mm : '0' + mm)
      return time
    }
  },
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.EndTime = this.getCurrentTime(0)
    this.BeginTime = this.getCurrentTime(1)
    this.getStatisticsReservoirWater()
    // this.getReserviorRate()
    this.$nextTick(() => {
      if (window.innerWidth >= 1800) {
        this.cellWidth = 'auto'
      } else if (window.innerWidth >= 1600) {
        this.cellWidth = '70'
      } else {
        this.cellWidth = '58'
      }
      let centerTable = this.$refs.centerTable
      this.tableHeight = centerTable.offsetHeight
      let reservoir = this.$refs.reservoirLine
      this.reservoirH = reservoir.offsetHeight
      this.reservoirW = reservoir.offsetWidth
    })
    this.timer = setInterval(() => {
      this.EndTime = this.getCurrentTime(0)
      this.BeginTime = this.getCurrentTime(1)
      this.getStatisticsReservoirWater()
      this.getReserviorRate()
    }, 1000 * 60 * 5)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }

}
</script>
<style lang='less' scoped>
*{
  box-sizing: border-box;
}
.homepage_left{
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 500;
  width: 520px;
  height: calc(100% - 85px);
  color: #fff;
  // background-image: linear-gradient(269deg, rgba(0,23,84,0.00) 0%, rgba(0,36,116,0.85) 100%);
  background-color: #1e346a;
  transition: all 1s ease;
}
.topDiv{
  width: 100%;
  height: 180px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    padding: 5px;
    font-size: 16px;
    background: rgba(0,0,0,0.2);
    .first{
      width: 100%;
      height: 100%;
      border: 1px dashed #3d65b7;
      margin-bottom: 5px;
      background: rgba(22,48,128,0.2);
      .bignum{
        font-size: 26px;
        color: #00eaff;
      }
    }
  }
}
.centerDiv{
  width: 100%;
  height: calc(100% - 9rem);
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    font-size: 16px;
    position: relative;
    .infotext{
      width: 100%;
      text-align: center;
      position: absolute;
      top:10px;
      left: 0;
    }
    #reservoirLine{
      width: 100%;
      height: 100%;
    }
  }
}
.bomDiv{
  width: 100%;
  height: 285px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    font-size: 16px;
    position: relative;
    position: relative;
    .reservoirDiv{
      width: 100%;
      height: 100%;
      .duanmianChart{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
      }
      .duanmianDiv{
        width: 96px;
        height: 100%;
        position: absolute;
        bottom: 0;
        left: 180px;
        margin: auto;
        z-index: 100;
        img{
          // width: 100%;
          height: 100%;
        }
      }
      .chartname{
        position: absolute;
        font-size: 14px;
        left: 10px;
        bottom: 10px;
        z-index: 10;
      }
      .overrun{
        height: 24px;
        line-height: 24px;
        padding: 0 5px;
        position: absolute;
        font-size: 14px;
        left: 80px;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #e02020;
        z-index: 10;
      }
      #reservoirLine{
        width: calc(100% - 230px);
        height: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 10;
      }
      .wave{
        width: calc(100% - 230px);
        height: 100%;
        overflow: hidden;
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
      }
      .wavelow{
        width: 230px;
        height: 100%;
        z-index: 1;
        overflow: hidden;
        position: absolute;
        right: 0;
        bottom: 0;
      }
      #piechart{
        position: absolute;
        top: 0;
        right: 0;
        width: 160px;
        height: 160px;
      }
    }
  }
}
.showBtn{
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  right: -30px;
  top: 50px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i{
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .tran180{
    transform: rotate(180deg);
  }
}
.closeBtn {
  left: -520px;
}
.titleDiv{
  height: 48px;
  line-height: 48px;
  padding-left: 30px;
  padding-right: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(60,110,251,1) , rgba(60,110,251,0)) 10;
  .title{
    font-size: 22px;
    height: 50px;
    align-items: center;
  }
  .more{
    font-size: 16px;
    cursor: pointer;
    /deep/ .el-radio-button__inner{
      color:#fff!important;
      background: rgba(0,0,0,0);
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      border-radius: 0;
    }
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background: #1f6fef;
    }
    // /deep/ .el-input__inner{
    //   width: 120px;
    //   padding: 0;
    //   background: none;
    //   color: #fff;
    //   border: 0;
    //   text-align: center;
    // }
  }
  .title_logo{
    height: 50px;
    margin-right: 10px;
    img{
      height: 20px;
    }
  }
  .icon{
    display: flex;
    height: 50px;
    align-items: center;
    margin-right: 10px;
    transform: skew(-31deg);
    div{
      &:nth-of-type(1){
        width: 15px;
        height: 18px;
        background: #3C6EFB;
      }
      &:nth-of-type(2){
        width: 10px;
        height: 18px;
        background: #F7E700;
      }
    }
  }
}

/deep/ .el-table{
  background: none!important;
  .cell{
    padding: 0;
  }
}

/deep/ .el-table__body tr.current-row>td{
  background-color: #69A8EA !important;
  color: #fff;
}
/deep/.el-table__empty-text{
  color: #fff;
}
/deep/.el-table tr {
  background-color: rgba(0,0,0,0);
}
/deep/ .el-table th{
  color: #fff;
  padding: 5px 0;
  background: #3C6EFB;
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}
/deep/ .el-table td{
  color: #fff;
  font-size: 13px;
  background: rgba(23,44,93,0.8);
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}

/deep/ .el-table .warning-red-row td{
  background: #d81539 !important
}
/deep/ .el-table--border{
  border: 1px solid #101e3e;
}
/deep/ .el-table--border::after,.el-table::before{
  background: none;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background: #0a37a0;
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}
.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexC {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flexFS {
  /* 左对齐 */
  justify-content: flex-start;
}

.flexFE {
  /* 右对齐 */
  justify-content: flex-end;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}

.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar{
  width: 0px;
  height: 7px;
  background-color: rgba(0,0,0,0);
}
// 测站查询框样式
.townSearch .el-input {
  display: inline-block;
  position: relative;
  top: 0rem;
  // right: 0.2rem;
  width: 180px;
}
.townSearch /deep/ .el-input__inner {
  background-color: transparent;
  border: 0.03125rem solid #079eb6;
  color: #ddd;
}
.townSearch /deep/ .el-input__inner:hover {
  border-color: #079eb6;
}
</style>
